import React from 'react';
import { InvitationStatus } from '../../graphql/generated/graphql';
import * as styles from './TeammateStatusLabel.module.scss';

const getLabelWithClassName = (
  deactivated?: boolean,
  invitationStatus?: InvitationStatus | null,
): { label: string; className?: string } => {
  if (deactivated) {
    return { label: 'Deactivated', className: styles.muted };
  }
  if (!deactivated && !invitationStatus) {
    return { label: 'Active' };
  }
  switch (invitationStatus) {
    case InvitationStatus.Sent:
      return { label: 'Invited', className: styles.muted };
    case InvitationStatus.Pending:
      return { label: 'Pending', className: styles.success };
    case InvitationStatus.Rejected:
      return { label: 'Rejected', className: styles.warning };
    default:
      return { label: '' };
  }
};

interface TeammateStatusLabelProps {
  deactivated?: boolean;
  invitationStatus?: InvitationStatus | null;
}

const TeammateStatusLabel = ({
  deactivated,
  invitationStatus,
}: TeammateStatusLabelProps) => {
  const { label, className } = getLabelWithClassName(
    deactivated,
    invitationStatus,
  );

  if (!label) {
    return null;
  }

  return <div className={className}>{label}</div>;
};

export default TeammateStatusLabel;
